import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import type { ReactElement } from 'react';

const MenuItemContent = styled.span(
  ({ theme }) => css`
    position: relative;

    &::after {
      content: '';
      position: absolute;
      background: ${theme.colors.main.shallow};
      top: 100%;
      margin-top: 4px;
      border-radius: 3px;
      left: 0%;
      width: 100%;
      height: 3px;
      transform: scaleX(0);
      transition: transform 0.2s;
      transform-origin: right center;
      box-sizing: border-box;
      display: block;
    }
  `
);

const MenuItemLink = styled(NavLink)(
  ({ theme }) => css`
    position: relative;
    color: ${theme.colors.white};
    font-size: ${theme.fonts.sizes.h4};
    font-weight: 500;
    display: block;
    padding: 12px 30px;
    margin: 6px 0;

    &:hover {
      ${MenuItemContent}::after {
        transition: transform 0.5s;
        transform: scaleX(1);
        transform-origin: left center;
      }
    }

    &.active {
      color: ${theme.colors.white};
      background-color: ${theme.colors.main.dark};

      ${MenuItemContent}::after {
        content: none;
      }
    }

    @media (max-width: ${theme.breakpoints.max.md}) {
      padding: 10px 15px;
      font-size: ${theme.fonts.sizes.h5};
    }
  `
);

const MenuItemIcon = styled.span(
  ({ theme }) => css`
    margin-right: ${theme.margins.sm};
    line-height: 20px;
    vertical-align: middle;

    @media (max-width: ${theme.breakpoints.max.md}) {
      margin-right: 12px;
      span {
        font-size: ${theme.fonts.sizes.h4} !important;
      }
    }
  `
);

type Props = {
  text: string;
  to: string;
  icon: ReactElement;
  id?: string;
};

const MenuItem = ({ to, icon, text, id }: Props) => {
  return (
    <MenuItemLink to={to} id={id}>
      <MenuItemContent>
        {icon && <MenuItemIcon>{icon}</MenuItemIcon>}
        <span id={id ? `${id}-link` : undefined}>{text}</span>
      </MenuItemContent>
    </MenuItemLink>
  );
};

export { MenuItem };
